import $ from 'jquery'
import 'slick-carousel'

/*************** Slider ***************/
$('.slider').slick({
	infinite: true,
	dots: false,
	arrows: true,
	adaptiveHeight: true,
	autoplay: true,
	autoplaySpeed: 12000,
})

$('.banner').fadeIn()

/*************** Gallery ***************/
$('.slide-gallery, .gallery-slider')
	.slick({
		dots: false,
		infinite: false,
		speed: 500,
		adaptiveHeight: true,
	})
	.fadeIn()

/*************** Testimonials Carousel ***************/
$('.testimonials-carousel')
	.slick({
		dots: true,
		infinite: true,
		speed: 500,
		adaptiveHeight: true,
		autoplay: true,
		autoplaySpeed: 12000,
	})
	.fadeIn()

/*************** Content Carousel ***************/
const bullet_array = []
$('.content-carousel-wrapper')
	.find('.slide')
	.each((index, item) => {
		bullet_array.push($(item).data('id'))
	})

$('.content-carousel')
	.slick({
		dots: true,
		infinite: true,
		speed: 500,
		adaptiveHeight: true,
		autoplay: true,
		autoplaySpeed: 12000,
		customPaging: function(slider, i) {
			if (bullet_array.length > 0) {
				return $('<button type="button" />').text(bullet_array[i])
			} else {
				return $('<button type="button" />').text(i + 1)
			}
		},
	})
	.fadeIn()
